import { PATHS } from "@u/routes";

/**
 * Sidebar section (breadcrumb group) each dashboard route belongs to — mirrors
 * the `navItems` groups in AppSidebar. Routes in the "General" group
 * (overview / .360 / .tap / health) return null: they get no section crumb.
 */
const SECTION_BY_ROUTE: { route: string; labelKey: string }[] = [
  // Clientes
  { route: PATHS.leads, labelKey: "nav_group_clients" },
  { route: PATHS.contacts, labelKey: "nav_group_clients" },
  { route: PATHS.bookings, labelKey: "nav_group_clients" },
  { route: PATHS.analytics, labelKey: "nav_group_clients" },
  // Organización
  { route: PATHS.users, labelKey: "nav_group_org" },
  // Configuración del sistema
  { route: PATHS.settings, labelKey: "system_config" },
  { route: PATHS.branding, labelKey: "system_config" },
  { route: PATHS.billing, labelKey: "system_config" },
  { route: PATHS.help, labelKey: "system_config" },
];

/** i18n key for the sidebar section a dashboard path lives in, or null when the
 *  path is in the General group (or isn't a sectioned dashboard route). */
export function dashboardSectionLabelKey(pathname: string): string | null {
  const match = SECTION_BY_ROUTE.find(
    ({ route }) => pathname === route || pathname.startsWith(`${route}/`),
  );
  return match?.labelKey ?? null;
}
